var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEB\x8B\xAB\xEA\xB8\xB0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 13165",
    d: "M13.3337 2.66602L2.66699 13.3327",
    stroke: "#999999",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 13166",
    d: "M13.3337 13.3327L2.66699 2.66602",
    stroke: "#999999",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.63d7aa9475e705c9a321641c486135ae.svg";
export { ForwardRef as ReactComponent };